// STRATURILE INSTALAȚIILOR din meniul vizualizatorului: câte o categorie
// (Apă, Ventilație, Electrice, Incendiu) care se aprinde întreagă, cu
// subcategoriile ei dedesubt — apă rece, apă caldă, canalizare, pluviale,
// încălzire —, fiecare cu pastila ei de culoare, aceeași din desen. Aceleași
// butoane (`meniu-comutator`, `dv-swatch`, `viewer.css`) ca restul straturilor.

import { useT } from "../i18n";
import { useInstalatii } from "./context";
import { CATEGORII, CULOARE_STRAT, numeStrat, stratul, type Strat } from "./model";
import "./instalatii.css";

export default function StraturiInstalatii() {
  const t = useT();
  const inst = useInstalatii();
  if (!inst) return null;
  const numar = new Map<Strat, number>();
  for (const s of inst.model?.segmente ?? []) numar.set(stratul(s), (numar.get(stratul(s)) ?? 0) + 1);
  const numeSistem = (s: Strat) => t(numeStrat(s));
  return (
    <div className="meniu-comutatoare inst-straturi">
      {/* planul 2D pe pardoseala machetei: deasupra sistemelor, fiindcă e
          reperul lor (unde e WC-ul, lavoarul, bucătăria), nu o instalație */}
      <button className={`meniu-comutator${inst.planPeJos ? " on" : ""}`} aria-pressed={inst.planPeJos}
              title={t(inst.planPeJos ? "inst.strat.stinge" : "inst.strat.aprinde", { ce: t("inst.strat.plan_pe_jos") })}
              onClick={inst.comutaPlanPeJos}>
        <span className="dv-swatch" aria-hidden="true" style={{ background: "#8a7660" }} />
        <span className="meniu-comutator-nume">{t("inst.strat.plan_pe_jos")}</span>
      </button>
      <button className={`meniu-comutator${inst.apartamente ? " on" : ""}`} aria-pressed={inst.apartamente}
              title={t(inst.apartamente ? "inst.strat.stinge" : "inst.strat.aprinde", { ce: t("inst.strat.apartamente") })}
              onClick={inst.comutaApartamente}>
        <span className="dv-swatch" aria-hidden="true" style={{ background: "#5c6bc0" }} />
        <span className="meniu-comutator-nume">{t("inst.strat.apartamente")}</span>
      </button>
      <button className={`meniu-comutator${inst.doarApartamentul ? " on" : ""}`} aria-pressed={inst.doarApartamentul}
              title={t("inst.strat.doar_apartamentul")} onClick={inst.comutaDoarApartamentul}>
        <span className="dv-swatch" aria-hidden="true" style={{ background: "#c5cae9" }} />
        <span className="meniu-comutator-nume">{t("inst.strat.doar_apartamentul")}</span>
      </button>
      {CATEGORII.map((c) => {
        const aprinse = c.straturi.filter((s) => inst.vizibile.has(s)).length;
        const toate = aprinse === c.straturi.length;
        return (
          <div key={c.categorie} className="inst-categorie">
            <button className={`meniu-comutator${aprinse ? " on" : ""}${aprinse && !toate ? " partial" : ""}`}
                    aria-pressed={toate ? true : aprinse ? "mixed" : false}
                    title={t(toate ? "inst.strat.stinge" : "inst.strat.aprinde", { ce: t(c.nume) })}
                    onClick={() => inst.comuta(c.straturi, !toate)}>
              <span className="inst-pastile" aria-hidden="true">
                {c.straturi.map((s) => <i key={s} style={{ background: CULOARE_STRAT[s] }} />)}
              </span>
              <span className="meniu-comutator-nume">{t(c.nume)}</span>
            </button>
            {c.straturi.length > 1 && (
              <div className="inst-subcategorii">
                {c.straturi.map((s) => {
                  const on = inst.vizibile.has(s);
                  const n = numar.get(s) ?? 0;
                  return (
                    <button key={s} className={`meniu-comutator${on ? " on" : ""}`} aria-pressed={on}
                            title={t(on ? "inst.strat.stinge" : "inst.strat.aprinde", { ce: numeSistem(s) })}
                            onClick={() => inst.comuta([s], !on)}>
                      <span className="dv-swatch" aria-hidden="true" style={{ background: CULOARE_STRAT[s] }} />
                      <span className="meniu-comutator-nume">{numeSistem(s)}</span>
                      {inst.model && <span className="meniu-comutator-nr">{n}</span>}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
